<template>
    <div class="channel-component">
        <div class="header-wrap">
            <el-card class="app-table-container" :body-style="{ padding: '20px' }">
                <div class="header-content">
                    <p>{{$t('content.store.channelPreview')}}</p>
                    <ul>
                        <li>logo</li>
                        <li v-for="n in 6" :key="n">分类</li>
                    </ul>
                </div>
            </el-card>
        </div>
        <div class="app-table-container body-wrap">
            <el-row :gutter="20">
                <el-col :span="12">
                    <DataTable
                    tableId="table-first"
                    :tableProps="selectedProps"
                    :tableData="selectedData"
                    :tableTitle="$t('content.store.channelSelected')"
                    @tableHandle="selectedHandle"
                    >
                    <!-- <pagination
                    layout="prev, pager, next"
                    :pageSize='selectedParams.limit'
                    :total="selectedTotal"
                    @pageNum="selectPageNum"
                    /> -->
                    </DataTable>
                </el-col>
                <el-col :span="12">
                    <DataTable
                    tableId="table-second"
                    :tableProps="selectableProps"
                    :tableData="selectableData"
                    :tableTitle="$t('content.store.channelSelected')"
                    @tableHandle="selectableHandle"
                    >
                    <!-- <pagination
                    layout="prev, pager, next"
                    :pageSize='selectableParams.limit'
                    :total="selectableTotal"
                    @pageNum="selectablePageNum"
                    /> -->
                    </DataTable>
                </el-col>
            </el-row>
        </div>
        <div class="footer-wrap">
            <button class="global-button-style">{{$t('commonMsg.save')}}</button>
        </div>
    </div>
</template>

<script>
import DataTable from '@/components/dataTable'
export default {
    components: {
        DataTable
    },
    computed: {
        selectedProps() {
            const selectedProps = [{
                prop: 'name',
                label: this.$t('content.store.channelName')
            },{
                prop: 'open',
                label: this.$t('content.store.channelOpen')
            },{
                prop: 'move',
                label: this.$t('commonMsg.sort')
            },{
                prop: 'handle',
                label: this.$t('commonMsg.handle'),
                width: 80,
                btn: [this.$t('commonMsg.del')]
            }]
            return selectedProps
        },
        selectableProps() {
            const selectableProps = [{
                prop: 'name',
                label: this.$t('content.store.channelName')
            },{
                prop: 'handle',
                label: this.$t('commonMsg.handle'),
                width: 80,
                btn: [this.$t('commonMsg.add')]
            }]

            return selectableProps
        }
    },
    data() {
        return {
            selectedData: [
                {
                    name: '特价'
                },
                {
                    name: '特价'
                },
                {
                    name: '特价'
                },
                {
                    name: '特价'
                },
                {
                    name: '特价'
                },
                {
                    name: '特价'
                },
                {
                    name: '特价'
                },
                {
                    name: '特价'
                },
                {
                    name: '特价'
                },
                {
                    name: '特价'
                },
                {
                    name: '特价'
                },
                {
                    name: '特价'
                },
            ],
            selectableData: [],
            selectedTotal: 0,
            selectableTotal: 0,
            selectedParams: {limit: 20, offset: 0},
            selectableParams: {limit: 20, offset: 0}
        }
    },
    methods: {
        getBookChannels() {
            this.$http.getBookChannels()
            .then(res => {
                this.selectableData = res.data.rows
            })
            .catch(() => {

            })
        },

        selectedHandle(value){
            this.selectedData.splice(value.data.$index, 1)
            this.selectableData = [...this.selectableData, value.data.row]
        },
        selectableHandle(value){
            // let isTure = this.selectedData.some(item => value.data.row.id === item.id)
            this.selectableData.splice(value.data.$index, 1)
            this.selectedData = [...this.selectedData, value.data.row]
        }
    },
    created() {
        // this.getBookChannels()
    }
}
</script>

<style lang="scss" scoped>
    .channel-component{
        flex: 1;
        display: flex;
        flex-direction: column;
        .header-wrap{
            .app-table-container{
                margin-bottom: 0;
                .header-content{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    padding: 30px 0;
                    p{
                        margin-bottom: 10px;
                        font-size: 20px;
                        font-weight: bold;
                    }
                    ul{
                        >li{
                            display: inline-block;
                            padding: 8px 20px;
                            border: 1px solid gray;
                        }
                        >li:first-of-type{
                            margin-right: 20px;
                        }
                    }
                }
            }
        }
        .body-wrap{
            flex: 1;
        }
        .footer-wrap{
            margin-bottom: 20px;
            text-align: center;
        }
    }
</style>
